(() => {
  'use strict';
  const KITS = new Set(['9898536239451','9898529096027','9898537746779','9898537353563']);
  const OFFER_TITLE = 'offre découverte';
  const TARGET_ATTRIBUTE = 'skinhye_discovery_target';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'fr-FR',{style:'currency',currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'}).format(cents / 100);
  const eligible = item => item && !KITS.has(String(item.product_id));
  const escapeHtml = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));
  const offerApplied = (cart, selectedVariantId) => {
    return (cart.items || []).some(item => {
      if (String(item.variant_id) !== String(selectedVariantId)) return false;
      const original = Number(item.original_line_price || 0);
      const final = Number(item.final_line_price || 0);
      const allocation = (item.line_level_discount_allocations || []).some(entry => {
        const app = entry.discount_application || entry;
        return String(app.title || '').toLocaleLowerCase('fr-FR').includes(OFFER_TITLE) && Number(entry.amount || 0) > 0;
      });
      return allocation && final < original;
    });
  };
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let requestVersion = 0;
  let desiredTarget = null;
  let selecting = false;
  let pendingCart = null;
  let refreshController = null;
  let lastCart = null;
  document.documentElement.dataset.skinhyeCartBuild = '20260912-native-build-1';
  document.documentElement.dataset.skinhyeDocumentStart = String(performance.timeOrigin);
  const status = (message, detail) => {
    document.querySelectorAll('[data-skinhye-discovery]').forEach(box => {
      box.hidden = false;
      box.querySelector('[data-skinhye-discovery-message]').textContent = message;
      box.querySelector('[data-skinhye-discovery-detail]').textContent = detail;
    });
  };
  const lock = value => {
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer) return;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-quantity-field], [data-quantity-button], [name="checkout"], [data-skinhye-upsell] button').forEach(control => {
      if (value && !control.disabled) {
        control.dataset.skinhyeLocked = 'true';
        control.disabled = true;
      } else if (!value && control.dataset.skinhyeLocked) {
        control.disabled = false;
        delete control.dataset.skinhyeLocked;
      }
    });
  };
  const nativeRender = cart => {
    const html = cart.sections && cart.sections['api-cart-items'];
    if (typeof html !== 'string' || !html.trim()) throw new Error('Rendu du panier indisponible');
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = parsed.querySelector('[data-api-content]');
    const total = content && content.querySelector('[data-cart-total]');
    const lines = content && content.querySelector('[data-api-line-items]');
    const upsells = content && content.querySelector('[data-api-upsell-items]');
    if (!content || !total || Number(total.dataset.cartTotal) !== Number(cart.total_price) ||
        (cart.item_count > 0 && (!lines || !upsells))) throw new Error('Rendu du panier incohérent');
    if (!window.cart || typeof window.cart.build !== 'function') throw new Error('Contrôleur du panier indisponible');
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer || !drawer.classList.contains('is-open')) {
      pendingCart = cart;
      return;
    }
    window.cart.build(content);
    pendingCart = null;
    render(cart);
    console.info('[Skinhye cart] rendered', JSON.stringify({total:cart.total_price,target:(cart.attributes || {})[TARGET_ATTRIBUTE],documentStart:performance.timeOrigin}));
  };
  const requestCart = async variantId => {
    const response = await fetch(root + 'cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({attributes:{[TARGET_ATTRIBUTE]:variantId},sections:['api-cart-items'],sections_url:location.pathname})
    });
    if (!response.ok) throw new Error('Impossible de mettre à jour le panier');
    const cart = await response.json();
    if (!Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) throw new Error('Réponse panier invalide');
    console.info('[Skinhye cart] response', JSON.stringify({status:response.status,total:cart.total_price,target:(cart.attributes || {})[TARGET_ATTRIBUTE],lines:cart.items.map(item=>({variant:item.variant_id,quantity:item.quantity,original:item.original_line_price,final:item.final_line_price,discounts:item.line_level_discount_allocations})),documentStart:performance.timeOrigin}));
    return cart;
  };
  const setTarget = async variantId => {
    desiredTarget = String(variantId);
    requestVersion++;
    if (refreshController) refreshController.abort();
    if (selecting) return;
    selecting = true;
    lock(true);
    let processed = null;
    try {
      while (desiredTarget !== null) {
        processed = desiredTarget;
        desiredTarget = null;
        status('Mise à jour de votre offre…', 'Votre panier reste ouvert pendant la mise à jour.');
        const cart = await requestCart(processed);
        if (desiredTarget !== null) continue;
        lastCart = cart;
        nativeRender(cart);
      }
    } catch (error) {
      status('La mise à jour du panier n’a pas abouti.', 'Votre panier est conservé. Sélectionnez à nouveau votre soin pour réessayer.');
      console.error('[Skinhye cart] update failed', error.message);
    } finally {
      selecting = false;
      lock(false);
      if (desiredTarget !== null) setTarget(desiredTarget);
    }
  };
  const renderPicker = (box, items, selectedVariantId, show) => {
    let picker = box.querySelector('[data-skinhye-discovery-picker]');
    if (!picker) {
      picker = document.createElement('label');
      picker.className = 'skinhye-discovery__picker';
      picker.setAttribute('data-skinhye-discovery-picker', '');
      box.appendChild(picker);
    }
    if (!show) { picker.hidden = true; return; }
    const variants = [...new Map(items.map(item => [String(item.variant_id), item])).values()];
    const options = variants.map(item => '<option value="' + escapeHtml(item.variant_id) + '"' + (String(item.variant_id) === String(selectedVariantId) ? ' selected' : '') + '>' + escapeHtml(item.product_title) + '</option>').join('');
    picker.hidden = false;
    picker.innerHTML = '<span>Choisissez le soin à -30 %</span><select aria-label="Choisissez le soin bénéficiant de l’Offre Découverte"><option value="">Sélectionner un soin</option>' + options + '</select>';
  };
  const render = cart => {
    const items = (cart.items || []).filter(eligible);
    const count = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const subtotal = items.reduce((sum, item) => sum + Number(item.original_line_price || 0), 0);
    const amountGap = Math.max(0, 5000 - subtotal);
    const unitsGap = Math.max(0, 3 - count);
    const conditionsMet = amountGap === 0 && unitsGap === 0;
    const selectedVariantId = cart.attributes && cart.attributes[TARGET_ATTRIBUTE];
    const selectedStillEligible = items.some(item => String(item.variant_id) === String(selectedVariantId));
    const active = conditionsMet && selectedStillEligible && offerApplied(cart, selectedVariantId);
    document.querySelectorAll('[data-skinhye-discovery]').forEach(box => {
      box.hidden = false;
      const message = box.querySelector('[data-skinhye-discovery-message]');
      const detail = box.querySelector('[data-skinhye-discovery-detail]');
      const bar = box.querySelector('[data-skinhye-discovery-bar]');
      const countLabel = box.querySelector('[data-skinhye-discovery-count]');
      const percent = Math.min(100, Math.round(((Math.min(subtotal,5000) / 5000) * 65) + ((Math.min(count,3) / 3) * 35)));
      countLabel.textContent = count + ' soin' + (count > 1 ? 's' : '') + ' éligible' + (count > 1 ? 's' : '');
      bar.style.width = percent + '%';
      renderPicker(box, items, selectedVariantId, conditionsMet);
      if (active) {
        message.textContent = 'Votre Offre Découverte est activée ✓';
        detail.textContent = 'Votre remise de -30 % est bien appliquée à votre total.';
      } else if (amountGap > 0) {
        message.textContent = 'Plus que ' + money(amountGap) + ' pour débloquer l’Offre Découverte';
        detail.textContent = unitsGap ? 'Ajoutez encore ' + unitsGap + ' soin' + (unitsGap > 1 ? 's' : '') + ' éligible' + (unitsGap > 1 ? 's' : '') + '.' : 'Le seuil de 3 soins est atteint.';
      } else if (unitsGap > 0) {
        message.textContent = 'Offre débloquée ! Ajoutez votre 3ᵉ soin et profitez de -30 %.';
        detail.textContent = 'Il manque encore ' + unitsGap + ' soin' + (unitsGap > 1 ? 's' : '') + ' éligible' + (unitsGap > 1 ? 's' : '') + '.';
      } else if (!selectedStillEligible) {
        message.textContent = 'Choisissez le soin auquel appliquer -30 %.';
        detail.textContent = 'Sélectionnez le soin qui bénéficiera de votre remise de -30 %.';
      } else {
        message.textContent = 'Votre sélection est enregistrée.';
        detail.textContent = 'Nous actualisons votre panier pour appliquer votre remise de -30 %.';
      }
    });
    document.querySelectorAll('[data-skinhye-upsell]').forEach(node => node.dataset.discoveryActive = active ? 'true' : 'false');
    return active;
  };

  const refresh = async () => {
    if (selecting) return;
    const version = ++requestVersion;
    if (refreshController) refreshController.abort();
    refreshController = new AbortController();
    try {
      const response = await fetch(root + 'cart.js',{headers:{Accept:'application/json'},cache:'no-store',signal:refreshController.signal});
      if (!response.ok) throw new Error('Lecture panier impossible');
      const cart = await response.json();
      if (version !== requestVersion || selecting) return;
      lastCart = cart;
      render(cart);
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('[Skinhye cart] read failed',error.message);
    }
  };
  const init = () => { refresh(); };
  document.addEventListener('theme:cart:added', () => { if (!selecting) refresh(); });
  document.addEventListener('theme:cart:loaded', refresh);
  document.addEventListener('theme:cart:open', () => queueMicrotask(() => {
    if (pendingCart) {
      try { nativeRender(pendingCart); } catch (error) {
        status('La mise à jour du panier n’a pas abouti.', 'Sélectionnez à nouveau votre soin pour réessayer.');
      }
    } else refresh();
  }));
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('click', event => {
    if (selecting && event.target.closest('[data-item-remove]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('change', event => {
    const picker = event.target.closest('[data-skinhye-discovery-picker] select');
    if (picker) setTarget(picker.value);
  });
})();

